import {NavigationActions} from "@ignitesales/neuro-application/src/neuro-guide/state/Navigation/NavigationActions";
import {SystemActions} from '@ignitesales/neuro-application/src/neuro-guide/state/App/AppActions';
import {installAnalytics, processPageView} from '../utils/analytics';

const analyticsReducer = (state, action) => {
  switch (action.type) {
    case SystemActions.APP_READY: {
        installAnalytics(state);
      break;
    }

    case NavigationActions.PAGE_REQUEST_COMPLETED: {
      processPageView(state);
      break;
    }

    default:
      break;
  }

  return state;
};

export default analyticsReducer;